import axios from 'axios';

import { actionData } from './actions';
import { save as saveCookies } from './cookies';
import sendToSegment from './sendToSegment';
import getVisitsData from './getVisitsData';
import getDeviceData from './getDeviceData';
import camelizeSnakeCase from './camelizeSnakeCase';
import config from '../config';

const prefixProperties = (object, prefix) => {
  return Object.keys(object).reduce((obj, key) => {
    const keyName = prefix + key.charAt(0).toUpperCase() + key.slice(1);
    return { ...obj, [keyName]: object[key] };
  }, {});
};

export const formatPayload = data =>
  Object.assign(
    {},
    {
      event: data.event,
      traits: {
        ...data.eventData,
        ...prefixProperties(data.history.initial, 'initial'),
        ...prefixProperties(data.history.last, 'last'),
        ...data.deviceData,
        [camelizeSnakeCase(data.action)]: new Date().getTime(),
        currentPageUrl: data.history.session.currentPageUrl,
        lastCapturedEvent: new Date().getTime(),
        visitsToSiteAllTime: data.history.userData.visitsToSiteAllTime,
        lastSessionPagesViewed: data.history.session.lastSessionPagesViewed,
      },
    },
  );

const convert = (action, data) => {
  saveCookies(action, data);

  const sourcebusterData = getVisitsData();

  const payload = formatPayload({
    action,
    event: actionData[action].eventName,
    eventData: data,
    deviceData: getDeviceData(sourcebusterData.userData.userAgent),
    history: sourcebusterData,
  });

  const segmentTraits = data.email ? { email: data.email } : {};
  sendToSegment(action, data.userId, segmentTraits);
  return axios.post(config.CONVERT_ENDPOINT, payload);
};

export default convert;
